<template>
    <div class="listing-settings">
        <CompassTooltip :content="title" :arrow="false">
            <CompassIconButton
                icon="settings"
                class="listing-settings__button"
                @click="openDialog"
            />
        </CompassTooltip>

        <CompassDialog
            :title="title"
            :primaryAction="primaryAction"
            :secondaryActions="secondaryActions"
            :visible="displaySettingsDialog"
            size="small"
            @update:visible="closeDialog"
        >
            <ListingSettingsColumn
                ref="listingSettingsColumn"
                :columns="newSettings.columns"
                :searchable="searchableColumns"
                @updateColumns="
                    (columns) => {
                        newSettings.columns = columns;
                    }
                "
            />
        </CompassDialog>
    </div>
</template>

<script>
import ListingSettingsColumn from 'vcomponents/common/listing/settings/ListingSettingsColumn.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('listingSettingsStores');

export default {
    components: {
        ListingSettingsColumn,
    },
    props: {
        searchableColumns: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            title: this.$t.__('listing.settings.ListingSettings.title'),
            displaySettingsDialog: false,
            settings: {},
            newSettings: {},
            primaryAction: {
                label: this.$t.__('common.actions.apply'),
                action: () => {
                    this.applySettings();
                },
            },
            secondaryActions: [
                {
                    label: this.$t.__('common.actions.reset'),
                    action: () => {
                        this.initSettings(true);
                    },
                },
            ],
        };
    },
    computed: {
        ...mapState(['columns', 'defaultColumns']),
    },
    created() {
        this.initSettings();
    },
    methods: {
        initSettings(initWithDefaultValues = false) {
            const initColumns = initWithDefaultValues ? this.defaultColumns : this.columns;
            this.newSettings = {
                columns: _.cloneDeep(initColumns),
            };
        },
        applySettings() {
            this.$emit('updateColumns', _.cloneDeep(this.newSettings.columns));
            this.$pushToast({
                type: 'success',
                icon: true,
                text: this.$t.__('listing.settings.ListingSettings.push_message.success'),
            });
            this.closeSettings();
        },
        openDialog() {
            this.displaySettingsDialog = true;
            this.settings = {
                columns: _.cloneDeep(this.newSettings.columns),
            };
        },
        closeDialog() {
            this.newSettings = {
                columns: _.cloneDeep(this.settings.columns),
            };
            this.closeSettings();
        },
        closeSettings() {
            this.displaySettingsDialog = false;
            this.$refs.listingSettingsColumn.resetSearchQuery();
        },
    },
};
</script>
